import React from 'react';
import LegalDocument from '../components/LegalDocument';
import termsEn from '../legal/terms.en.json';
import termsZh from '../legal/terms.zh.json';

const content = { en: termsEn, zh: termsZh };

function Terms({ language }) {
  const doc = content[language] || content.en;

  return (
    <div className="legal-page">
      <LegalDocument
        title={doc.title}
        effective={doc.effective}
        lastUpdated={doc.lastUpdated}
        intro={doc.intro}
        tocLabel={doc.toc}
        backLabel={doc.back}
        sections={doc.sections}
      />
    </div>
  );
}

export default Terms;
